import Gaplite from './Gaplite';

export default Gaplite;
